<template>
  <div class="main">
    <fast-nav></fast-nav>
    <div class="header">
      <el-card class="box-card">
        <table class="head-table">
          <tbody>
          <tr>
            <td class="td_name">游戏硬盘</td>
            <td>{{ diskName }}</td>
          </tr>
          <tr>
            <td class="td_name">实际容量</td>
            <td>{{ diskTotal }}G</td>
          </tr>
          <tr>
            <td class="td_name">已选游戏总容量</td>
            <td>{{ selectdGameTotalSize }}G</td>
          </tr>
          <tr>
            <td class="td_name">剩余容量</td>
            <td>{{ freeSize }}G</td>
          </tr>
          <tr>
            <td class="td_name">游戏总数</td>
            <td>
              <div class="el-badge item">
                <el-badge :value="selectdGame.length" class="item" type="primary">
                  <el-button type="warning" size="mini" @click="drawer = true">查看已选游戏</el-button>
                </el-badge>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="send_btns">
          <div class="is-justify-center">
            <el-button type="primary" @click="editPhone">立即提交</el-button>
            <el-button type="success" @click="resetForm">重置</el-button>
            <el-button type="warning" @click="formRecordDialog">提交记录</el-button>
          </div>
        </div>
      </el-card>
    </div>
    <div class="config">
      <el-row>
        <el-col :xs="24" :sm="12">
          <el-card>
            <div slot="header" class="clearfix">
              <p><span style="color: rgb(64, 158, 255);">购买主机选内置硬盘</span></p>
            </div>
            <el-radio-group v-model="form.inDiskId" size="mini">
                    <el-radio v-for="item in hardDisk" :key="item.id" :label="item.id" @click.native.prevent="inDiskChange(item.id)" border>{{ item.title }}
                    </el-radio>
            </el-radio-group>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-card>
            <div slot="header" class="clearfix">
              <p><span style="color: rgb(103, 194, 58);">购买外置硬盘请选择</span></p>
            </div>
              <el-radio-group v-model="form.outDiskId" size="mini">
                      <el-radio  v-for="item in attachHardDisk" :key="item.id"
                                 :label="item.id" @click.native.prevent="outDiskChange(item.id)" border style="margin-left: 0px;margin-bottom: 10px">{{ item.title }}
                      </el-radio>
              </el-radio-group>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="diy-message">
      <el-alert
        title="温馨提示"
        type="success"
      >
        1：凡是选游戏要求截图发给他的都是盗用我们家游戏目录的，必须请选好游戏立即提交留言，这样我们后台会收到您选的游戏记录，会按照您选的来指定安装！
        <br/>
        2：主机安装系统会占用空间所以与实际容量有差异， 选装游戏时需要预留空间做为存档和安装游戏数据，以网页选装提示满了为止，
        自选安装游戏需要一定时间 预计36小时左右 请耐心等待！！！
      </el-alert>
    </div>
    <div class="content">
      <div class="search">
        <el-input placeholder="请输入游戏名称" v-model="search.keywords">
          <el-button slot="append" @click="searchData" icon="el-icon-search"></el-button>
        </el-input>

        <div style="margin: 5px 0px 5px 0px" size="mini">
          <el-radio-group v-model="search.gametype" @change="searchData">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button  v-for="item in gameTypeList" :key="item.id" :label="item.id" >{{item.title}}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="game-list">
        <ul class="infinite-list" :infinite-scroll-immediate="false"
            :infinite-scroll-distance="10"
            v-infinite-scroll="nextPageData" style="overflow:auto">
          <li class="game-item-con" v-for="item in gameList" :key="item.id">
            <div class="game-item" @click="selectGame(item)">
              <div class="card" :class="{on:isSelect(item)}">
                <div class="thumb" :style="{'background-image':'url('+ website.apiURL + item.litpic +')'}">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH4AAACeCAYAAAD0Z74KAAAACXBIWXMAAAsTAAALEwEAmpwYAAAF7mlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXA6Q3JlYXRlRGF0ZT0iMjAyMS0xMC0xOVQyMzowMTo0NiswODowMCIgeG1wOk1vZGlmeURhdGU9IjIwMjEtMTAtMTlUMjM6MDM6NDkrMDg6MDAiIHhtcDpNZXRhZGF0YURhdGU9IjIwMjEtMTAtMTlUMjM6MDM6NDkrMDg6MDAiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzQ5MjExZGUtYjZmZS1kZTRjLWJkMDYtOTQyYTM4YTRiMjdkIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkI5ODAxRUM3QTJFNTExRTlCMzFCRUQ1OTJBMzlFQTI0IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6Qjk4MDFFQzdBMkU1MTFFOUIzMUJFRDU5MkEzOUVBMjQiIGRjOmZvcm1hdD0iaW1hZ2UvcG5nIiBwaG90b3Nob3A6Q29sb3JNb2RlPSIzIiBwaG90b3Nob3A6SUNDUHJvZmlsZT0ic1JHQiBJRUM2MTk2Ni0yLjEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCOTgwMUVDNEEyRTUxMUU5QjMxQkVENTkyQTM5RUEyNCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCOTgwMUVDNUEyRTUxMUU5QjMxQkVENTkyQTM5RUEyNCIvPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDozNDkyMTFkZS1iNmZlLWRlNGMtYmQwNi05NDJhMzhhNGIyN2QiIHN0RXZ0OndoZW49IjIwMjEtMTAtMTlUMjM6MDM6NDkrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5mWAREAAABgUlEQVR4nO3RQREAIAzAMMC/5yFjjyYKetc7M4eetx3ADuOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4KOOjjI8yPsr4qA8z+QQ5a6YM7QAAAABJRU5ErkJggg=="
                    alt="">
                </div>
                <div class="item-text">
                  <div class="title">{{ item.title }} <span class="lang">【{{ item.language }}】</span>
                  </div>
                  <div class="info">
                    <div class="code">编号：{{ item.flag }}</div>
                    <div class="game-size">容量：{{ item.gamesize }}G</div>
                  </div>
                </div>
                <div class="new_flag" :class="{on:item.is_news == 1}">
                  <span>新品</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      :size="drawerSize"
      :with-header="false">
      <div class="">
        <div class="drawer_header"> 已选择游戏列表<span>{{ selectdGame.length }}</span>
        </div>
      </div>
      <div class="game-list">
        <ul class="selectd-game-list">
          <li class="selectd-game-item-con" v-for="item in selectdGame" :key="item.id">
            <div class="game-item">
              <div class="card">
                <div class="thumb" :style="{'background-image':'url('+ website.apiURL + item.litpic +')'}">
                  <img
                    src="data:image/png;base64,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"
                    alt="">
                </div>
                <div class="item-text">
                  <div class="title">{{ item.title }} <span class="lang">【{{ item.language }}】</span>
                  </div>
                  <div class="info">
                    <div class="code">编号：{{ item.flag }}</div>
                    <div class="game-size">容量：{{ item.gamesize }}G</div>
                  </div>
                </div>
                <div class="new_flag on">
                  <span v-if="item.is_news === 1">新品</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </el-drawer>
    <el-drawer
      :visible.sync="drawerRecord"
      direction="rtl"
      :size="drawerSize"
      :with-header="false">
      <div class="">
        <div class="drawer_header"> 提交历史
        </div>
      </div>
      <el-table
        :data="historySubmitList"
        style="width: 100%">
        <el-table-column
          label="提交日期"
          prop="createDate">
        </el-table-column>
        <el-table-column label="相关操作" width="170">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleBuyBack(scope.row)">再来一单
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="deleteHistory(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>

    <el-dialog
      title="联系方式"
      :visible.sync="phoneDialogVisible"
      width="350px"
      :before-close="handleClose">
      <div>
        <div class="tixing">填写用户信息 <span class="storg">(注意： 为了核对游戏是否正确，请留下手机号，方便商家与您核对。 )</span>
        </div>
        <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="phoneDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import {gameAll, getInitData, formMessage} from '@/api/gameType'
import {validatenull} from '@/util/validate'
import {getStore, setStore, removeStore} from '@/util/store'
import {dateFormat} from '@/util/date'
import nav from '@/components/nav.vue'

export default {
  name: 'GameType',
  components: { 'fast-nav': nav},
  data() {
    return {
      form: {
        inDiskId: null,// 内置硬盘ID
        outDiskId: null,// 外置硬盘ID
        inDiskSize: 0, // 内置硬盘大小
        outDiskSize: 0, // 外置硬盘大小
        phone: "", // 手机号
      },
      search: {
        keywords: "",
        page: 1,
        tid: "",
        gametype:""
      },
      pager: { // 分页器
        currentPage: 1,
        lastPage: 0,
      },
      gameList: [],  // 游戏列表
      attachHardDisk: [],  // 外置硬盘列表
      hardDisk: [],  // 内置硬盘列表
      gameTypeList: [], // 游戏类型
      selectdGame: [], // 选择的游戏
      drawer: false, // 展示已经选游戏
      drawerRecord: false, // 历史记录显示
      drawerSize: "40%", // 显示已经选择游戏的宽度
      loading: false,//数据加载动画
      saveLoading: false,// 保存中状态
      phoneDialogVisible: false, // 手机dialog开启
      historySubmitList: [], // 历史提交记录
    }
  },
  computed: {
    // 硬盘名称
    diskName() {
      if (this.form.inDiskId !== null && this.form.outDiskId !== null) {
        return "内置 + 外置";
      } else if (this.form.inDiskId !== null) {
        return "内置";
      } else if (this.form.outDiskId !== null) {
        return "外置";
      } else {
        return "";
      }
    },
    // 硬盘总大小
    diskTotal() {
      return this.form.inDiskSize + this.form.outDiskSize;
    },
    // 是否存在游戏
    noMore() {
      return this.lastPage === 0 ? false : (this.currentPage >= this.lastPage ? true : false);
    },
    // 选择的游戏ID
    selectdGameIds() {
      return this.selectdGame.map(item => item.aid);
    },
    // 计算选择的游戏的总容量大小
    selectdGameTotalSize() {
      let totalSize = 0;
      this.selectdGame.forEach(item => {
        totalSize += item.gamesizeEnlarge;
      })
      return totalSize / 100;
    },
    // 可用硬盘容量
    freeSize() {
      return (parseInt(this.diskTotal * 100) - parseInt(this.selectdGameTotalSize * 100)) / 100;
    }

  },
  created() {
    this.search.tid = this.$route.query.gameTypeId;
    getInitData(this.search.tid).then(res => {
      const data = res.data.data;
      this.attachHardDisk = data.attach_hard_disk;
      this.hardDisk = data.hard_disk;
      this.gameTypeList = data.game_type_list;
    });

    // 恢复上次未保存的数据
    this.recoverData();
    // 获取历史提交记录
    this.getHistoryList();

    // 初始化化显示已选择游戏的宽度
    let clientWidth = document.documentElement.clientWidth;
    if (clientWidth <= 768) {
      this.drawerSize = "80%";
    } else if (clientWidth <= 992) {
      this.drawerSize = "60%";
    } else {
      this.drawerSize = "40%";
    }
  },
  methods: {
    // 切换栏目
    changeItem(tid) {
      if (this.search.tid != tid) {
        this.search.tid = tid;
        // 选择的游戏去除
        this.selectdGame = [];
        this.searchData();
      }
    },
    // 搜索
    searchData() {
      this.pager.currentPage = 1;
      this.gameList = [];
      this.getData();
    },
    // 获取数据
    getData() {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      this.search.page = this.pager.currentPage;
      gameAll(this.search).then(res => {
        const data = res.data.data;
        this.pager.currentPage = data.current_page;
        this.pager.lastPage = data.last_page;
        this.pager.currentPage += 1;
        // 对游戏数据进行处理
        data.data.forEach(item => {
          // 保持浮点型数据
          item['gamesizeFloat'] = parseFloat(item.gamesize);
          // 放大100倍，方便后期计算
          item['gamesizeEnlarge'] = parseInt(item['gamesizeFloat'] * 100);
        })
        this.gameList = [...this.gameList, ...data.data];
      }).finally(() => {
        this.loading = false;
      })
    },
    // 内置硬盘选择
    inDiskChange(value) {
      if (value === this.form.inDiskId) {
        // 如果取消后磁盘空间小于游戏空间，则不允许取消
        if ((this.selectdGameTotalSize * 100) > (this.form.outDiskSize * 100)) {
          this.$message({
            message: '取消后的主机磁盘小于游戏总大小',
            type: 'error'
          });
          return false;
        }

        this.form.inDiskId = null;
        this.form.inDiskSize = 0;
      } else {
        let item = this.hardDisk.find(item => item.id === value);
        this.form.inDiskSize = item.size;
        this.form.inDiskId = value;
      }
      // 记录当前修改的数据状态
      this.saveCurrentNotSubmitForm()
    },
    // 外置硬盘选择
    outDiskChange(value) {
      if (value === this.form.outDiskId) {
        // 如果取消后磁盘空间小于游戏空间，则不允许取消
        if ((this.selectdGameTotalSize * 100) > (this.form.inDiskSize * 100)) {
          this.$message({
            message: '取消后的主机磁盘小于游戏总大小',
            type: 'error'
          });
          return false;
        }

        this.form.outDiskSize = 0;
        this.form.outDiskId = null;
      } else {
        let item = this.attachHardDisk.find(item => item.id === value);
        this.form.outDiskSize = item.size;
        this.form.outDiskId = value;
      }

      // 记录当前修改的数据状态
      this.saveCurrentNotSubmitForm()
    },
    // 无线加载
    nextPageData() {
      if (!validatenull(this.search.tid)) {
        this.search.page = this.search.page + 1;
        this.getData();
      }
    },
    // 选择游戏
    selectGame(item) {
      // 判断是否选择了硬盘
      if (this.diskTotal === 0) {
        this.$message({
          message: '请选择游戏硬盘',
          type: 'warning'
        });
        return false;
      }
      // 判断是否已经选择了
      if (this.selectdGameIds.includes(item.aid)) {
        // 取消选择
        this.selectdGame = this.selectdGame.filter(res => res.aid != item.aid);
      } else {
        // 选择

        // 判断硬盘容量是否足够,放大100计算更精准
        if (parseInt(this.diskTotal * 100) < ((this.selectdGameTotalSize * 100) + item.gamesizeEnlarge)) {
          this.$message({
            message: '您选的游戏硬盘已经装不下了',
            type: 'warning'
          });
          return false;
        }
        this.selectdGame.push(item);
      }

      // 记录当前修改的数据状态
      this.saveCurrentNotSubmitForm()
    },
    // 判断当前游戏是否被选中
    isSelect(item) {
      return this.selectdGameIds.includes(item.aid);
    },
    // 已经选游戏列表关闭
    handleClose(done) {
      done();
    },
    // 数据重置
    resetForm() {
      this.form = {
        inDiskId: null,// 内置硬盘ID
        outDiskId: null,// 外置硬盘ID
        inDiskSize: 0, // 内置硬盘大小
        outDiskSize: 0, // 外置硬盘大小
        phone: "", // 手机号
      };
      this.selectdGame = [];
    },
    // 表单提交
    submitForm() {
      if (this.saveLoading) {
        return;
      }
      this.saveLoading = true;
      // 判断是否选择了游戏
      if (this.selectdGameIds.length === 0) {
        this.$message({
          message: '请选择游戏',
          type: 'warning'
        });
        this.saveLoading = false;
        return false;
      }

      // 判断手机号是否填写
      if (validatenull(this.form.phone)) {
        this.$message({
          message: '请填写手机号',
          type: 'warning'
        });
        this.saveLoading = false;
        return false;
      }

      // 组装数据
      let saveForm = {
        arctypeid:this.search.tid,
        phone: this.form.phone,
        game: this.selectdGameIds.join(",")
      };
      if (!validatenull(this.form.inDiskId)) {
        saveForm['c_id'] = this.form.inDiskId;
      }
      if (!validatenull(this.form.outDiskId)) {
        saveForm['c_id1'] = this.form.outDiskId;
      }

      formMessage(saveForm).then(res => {
        if (res.data.status === true) {
          this.phoneDialogVisible = false;
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
          // 保存到历史记录
          this.saveCurrentStore();
          // 更新提交历史
          this.getHistoryList();

          // 重置表单
          this.resetForm();
          // 删除本地保存的当前数据
          this.deleteCurrentNotSubmitForm();
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          });
        }
      }).finally(() => {
        this.saveLoading = false;
      })
    },
    // 编辑手机号弹框
    editPhone() {
      this.phoneDialogVisible = true;
    },
    // 获取当前数据
    currentGameData() {
      // 获取当前时间
      let currentDate = new Date();
      return {
        form: this.form,
        selectdGame: this.selectdGame,
        createDate: dateFormat(currentDate),
        timeStamp: currentDate.getTime()
      };
    },
    // 保存当前订单到本地存储历史列表中
    saveCurrentStore() {
      let currentDate = this.currentGameData();

      let selectGameList = getStore({name: "historyList_"+this.search.tid});
      if (validatenull(selectGameList))
        selectGameList = [];

      selectGameList.push(currentDate);
      setStore({name: "historyList_"+this.search.tid, content: selectGameList, type: false});
    },
    //保存未提交的数据，防止切换手机切换后台导致数据丢失
    saveCurrentNotSubmitForm() {
      let currentData = this.currentGameData();
      setStore({name: "formData_"+this.search.tid, content: currentData, type: false});
    },
    // 删除未提交的数据
    deleteCurrentNotSubmitForm() {
      removeStore({name: "formData_"+this.search.tid, type: false})
    },
    // 恢复上次未提交的数据
    recoverData() {
      let currentData = getStore({name: "formData_"+this.search.tid});
      if (!validatenull(currentData)) {
        this.form = currentData.form;
        this.selectdGame = currentData.selectdGame;
      }
    },

    // 获取提交历史
    getHistoryList() {
      let historyList = getStore({name: "historyList_"+this.search.tid});
      if (!validatenull(historyList)) {
        this.historySubmitList = historyList;
      }
    },
    // 历史记录弹框
    formRecordDialog() {
      this.drawerRecord = true;
    },
    // 再来一单
    handleBuyBack({timeStamp}) {

      let selectItem = this.historySubmitList.find(item => item.timeStamp === timeStamp);
      if (!validatenull(selectItem)) {
        selectItem.form.phone = ""; // 手机号不恢复
        this.form = selectItem.form;
        this.selectdGame = selectItem.selectdGame;
      }
      this.drawerRecord = false;
    },
    // 删除提交历史
    deleteHistory({timeStamp}) {

      this.historySubmitList = this.historySubmitList.filter(item => item.timeStamp !== timeStamp);
      setStore({name: "historyList_"+this.search.tid, content: this.historySubmitList, type: false});

    }
  }
}
</script>
<style scoped>
.main {
  max-width: 1200px;
  margin: 0 auto;
}

.header h1 {
  text-align: center;
  line-height: 45px;
  background: #F56C6C;
  color: #fff;
  font-size: 18px;
  border-bottom: 1px solid #ececec;
  margin: 0;
}

.head-table {
  width: 100%;
  background-color: #fff;
  color: #666;
  border-collapse: collapse;
  border-spacing: 0;
}

.head-table tr {
  transition: all .3s;
  -webkit-transition: all .3s;
}

.head-table td, .head-table th {
  position: relative;
  padding: 9px 15px;
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
}

.head-table td {
  border-width: 1px;
  border-style: solid;
  border-color: #eee;
}

.head-table .td_name {
  width: 10rem;
}

.head-table td, .head-table th {
  position: relative;
  padding: 9px 15px;
  min-height: 20px;
  line-height: 20px;
  font-size: 14px;
}

.head-table td {
  border-width: 1px;
  border-style: solid;
  border-color: #eee;
}

.config {
  margin-top: 15px;
}

.radio-box {
  margin-bottom: 10px;
}

.diy-message {
  margin-top: 15px;
}

.content {
  margin-top: 15px;
}

.category {
  background-color: #f4f5f7;
}

.category .tab-item {
  display: inline-block;
  padding: 1rem;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.category .tab-item.on {
  background-color: #fff;
  color: #0d84ff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.game-item {
  box-sizing: border-box;
  padding: 0.2rem;
}

.game-item .card {
  border-width: 2px;
  border-style: solid;
  border-color: #aaa;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.game-item .card.on {
  border-color: #67c23a;
  box-shadow: 0 0 5px #67c23a;
}

.thumb {
  background-position: center center;
  background-size: cover;
}

.thumb img {
  width: 100%;
}

.item-text {
  box-sizing: border-box;
  padding: 0.5rem;
}

.item-text .title {
  font-size: .8rem;
  margin-bottom: 0.5rem;
}

.infinite-list {
  height: 100vh;
  padding: 0;
  margin: 0;
  list-style: none;
}

.item-text .title {
  font-size: .8rem;
  margin-bottom: 0.5rem;
}

.item-text .info {
  display: flex;
  justify-content: space-between;
  font-size: .7rem;
}

.new_flag {
  position: absolute;
  top: 0;
  right: 0;
  display: none;
  border-bottom-left-radius: 10px;
  overflow: hidden;
}

.new_flag.on {
  display: block;
}

.new_flag span {
  display: inline-block;
  padding: 3px 10px;
  background-color: red;
  font-size: 12px;
  color: #fff;
  font-weight: 500;
}

.loading {
  text-align: center;
}

.no-more {
  text-align: center;
}

.game-item-con {
  display: inline-block;
  vertical-align: top;
}

.selectd-game-item-con {
  display: inline-block;
  vertical-align: top;
}

.game-item .card.on {
  border-color: #F56C6C;
  box-shadow: 0 0 5px #F56C6C;
}

.game-item .card.on:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(253, 226, 226,.5);
}

.drawer_header {
  padding: 0.4rem;
  color: #72767b;
  border-bottom: 1px solid #999;
  font-weight: 500;
  background-color: #fff;
  height: 35px;
  box-sizing: border-box;
}

.drawer_header span {
  padding: 3px 10px;
  border-radius: 10px;
  background-color: #409eff;
  margin-left: 15px;
  color: #fff;
  font-weight: 700;
}

.selectd-game-list {
  height: calc(100vh - 35px);
  overflow-y: scroll;
}

.send_btns {
  margin-top: 0.8rem;
}

.is-justify-center {
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.tixing {
  color: #1153a8;
  margin-bottom: 15px;
}

.tixing .storg {
  color: #e53333;
}

@media screen and (max-width: 768px) {
  .game-item-con {
    width: 50%;
  }

  .selectd-game-item-con {
    width: 50%;
  }
}

@media screen and (min-width: 768px) {
  .game-item-con {
    width: 33.33%;
  }

  .selectd-game-item-con {
    width: 33.33%;
  }
}

@media screen and (min-width: 992px) {
  .game-item-con {
    width: 25%;
  }
}
</style>
